import React from 'react';
import { motion } from 'framer-motion';
import { GoldRule } from './GoldRule';
import { CategoryBanner, ServiceThumb } from './ServiceMedia';
import { useLanguage } from './i18n/LanguageContext';
import { getServiceCategories } from './i18n/servicesCopy';
export function Services() {
  const {
    lang,
    t
  } = useLanguage();
  const serviceCategories = getServiceCategories(lang);
  return <section id="servicios" className="max-w-2xl mx-auto px-6 scroll-mt-24" data-id="element-354" data-mp="13vl7qccu6x0y">
      <GoldRule data-id="element-355" data-mp="13xpldm0jfaef">{t.services.rule}</GoldRule>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-80px'
    }} transition={{
      duration: 0.7
    }} data-id="element-356" data-mp="z43gwh4j2ctp">
        <p className="font-body font-semibold text-[11px] tracking-[5px] uppercase text-gold mb-3" data-id="element-357" data-mp="q618vhmdmjwx">
          {t.services.eyebrow}
        </p>
        <h2 className="font-serif text-dark text-3xl sm:text-4xl leading-tight mb-4" data-id="element-358" data-mp="g6abn86flqt5">
          {t.services.titleTop}
          <br data-id="element-359" data-mp="36bxz6izgefhf" />
          <em className="italic text-gold" data-id="element-360" data-mp="36besxzj61fj8">{t.services.titleBottom}</em>
        </h2>
        <p className="font-body font-light text-mid text-sm leading-[1.85] mb-10" data-id="element-361" data-mp="3b3pv791dpdey">
          {t.services.body}
        </p>
      </motion.div>

      <div className="space-y-10" data-id="element-362" data-mp="2xdmd8u9j85vb">
        {serviceCategories.map((cat, ci) => {
        const Icon = cat.icon;
        return <motion.div key={cat.name} initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.6,
          delay: ci * 0.05
        }} data-id="element-363" data-mp="328i61wmlex9h" data-mpi={ci}>
              <div className="flex items-center gap-4 pb-3 mb-4 border-b border-brand-border" data-id="element-364" data-mp="3l1dn7r7lo6tf">
                <span className="metallic-gold-surface w-12 h-12 rounded-full border border-metallic-border flex items-center justify-center flex-shrink-0 shadow-[0_3px_10px_rgba(183,144,72,0.28)]" data-id="element-365" data-mp="24n40f1j0aq4p">
                  <Icon className="w-6 h-6 text-white drop-shadow-[0_1px_1px_rgba(73,53,20,0.35)]" strokeWidth={1.7} data-id="element-366" data-mp="1pk2vn4vq6brr" />
                </span>
                <h3 className="font-serif text-dark text-xl sm:text-2xl tracking-wide" data-id="element-367" data-mp="1ljk318m0d1oi">
                  {cat.name}
                </h3>
              </div>

              {cat.image && <CategoryBanner src={cat.image} alt={cat.imageAlt ?? cat.name} label={cat.name} data-id="element-368" data-mp="1bsxpdjxuql8g" />}

              <div data-id="element-369" data-mp="16tcv3mtmn122">
                {cat.items.map(item => <div key={item.name} className="group flex justify-between items-start gap-4 sm:gap-5 py-3.5 border-b border-brand-border/40 last:border-b-0" data-id="element-370" data-mp="16v60yzwf1h90">
                    {item.image && <ServiceThumb src={item.image} alt={item.name} data-id="element-371" data-mp="xs4yd96re8a3" />}
                    <div className="flex-1" data-id="element-372" data-mp="su3ckghy7uux">
                      <div className="font-body font-medium text-dark text-sm mb-1 tracking-[0.3px]" data-id="element-373" data-mp="sv4y5ewlbzqw">
                        {item.name}
                      </div>
                      <div className="font-body font-light text-soft text-xs leading-[1.6]" data-id="element-374" data-mp="2n7bdmpwip2p0">
                        {item.desc}
                      </div>
                    </div>
                    <div className="text-right min-w-[90px] pt-0.5" data-id="element-375" data-mp="2zqgpgdy2okri">
                      <div className="font-serif font-medium text-champagne-deep text-lg whitespace-nowrap" data-id="element-376" data-mp="2zom10pnleaio">
                        {item.price}
                      </div>
                      {item.note && <span className="block font-body font-light text-soft text-[10px] mt-0.5" data-id="element-377" data-mp="39fqko2o7qjju">
                          {item.note}
                        </span>}
                    </div>
                  </div>)}
              </div>
            </motion.div>;
      })}
      </div>
    </section>;
}